import { useQuery } from '@tanstack/react-query'

import { pedir } from './nucleo'

/** Lo que cuenta el núcleo de las visitas de una web (`GET /api/panel/visitas`, CLAUDE.md §34). */
export type ResumenDeVisitas = {
  desde: string
  hasta: string
  totales: { visitas: number; personas: number }
  anteriores: { visitas: number; personas: number }
  serie: Array<{ dia: string; visitas: number; personas: number }>
  paginas: Array<{ ruta: string; titulo: null | string; visitas: number }>
  referentes: Array<{ valor: string; visitas: number }>
  paises: Array<{ valor: string; visitas: number }>
  dispositivos: Array<{ valor: string; visitas: number }>
  campanas: Array<{ valor: string; visitas: number }>
  formularios: Array<{ id: number; nombre: string; respuestas: number; visitas: number; conversion: null | number }>
}

export const useVisitas = (sitio: number, dias: number, habilitado = true) =>
  useQuery({
    queryKey: ['visitas', sitio, dias],
    enabled: habilitado,
    queryFn: () => pedir<ResumenDeVisitas>(`/panel/visitas?sitio=${sitio}&dias=${dias}`),
    // El enrutador apunta cada minuto: con la pantalla abierta se ve llegar.
    refetchInterval: 120_000,
    staleTime: 60_000,
  })

/** «+12 %» o «−8 %» respecto al periodo anterior; nada si antes no hubo visitas que comparar. */
export const cambio = (ahora: number, antes: number): null | string => {
  if (antes <= 0) return null
  const p = Math.round(((ahora - antes) / antes) * 100)
  return `${p > 0 ? '+' : p < 0 ? '−' : ''}${Math.abs(p)} %`
}

const PAISES = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['es'], { type: 'region' }) : null
/** «PE» → «Perú». */
export const nombreDePais = (codigo: string): string => {
  try {
    return PAISES?.of(codigo) ?? codigo
  } catch {
    return codigo
  }
}

export const DISPOSITIVOS: Record<string, string> = { movil: 'Móvil', escritorio: 'Computadora', tableta: 'Tableta' }
